import axios from 'axios'

export function request(config){
  const instance = axios.create({
    // API基础URL
    baseURL: process.env.VUE_APP_API_URL,
    method: 'GET',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true,// 跨域请求时是否需要凭证
  })

  // 请求拦截
  instance.interceptors.request.use(config => {
    // 在每个请求发送之前修改配置
    config.data = config.data || {};
    config.data['actId'] = process.env.VUE_APP_API_ACTID;
    
    return config;
  }, error => {
    return Promise.reject(error);
  });

  // 响应拦截
  instance.interceptors.response.use(res => {
    return res.data;
  }, err => {
    return Promise.reject(err);
  })
  
  return instance(config)
}
